import CustomeIcon from "../../components/CustomeIcon";
import React from "react";
import Accordion from "../../components/Accordion";
import AccordionHeading from "../../components/AccordionHeading";
import AccordionContent from "../../components/AccordionContent";
import Button from "../../components/Button";
import IconMenu from "./IconMenu";
import MenuItem from "./MenuItem";
import { useGlobalContext } from "../../services/DataMain";
import PopUp from "../PopUp";
import CompPopUp from "../CompPopUp";
import NonCompatiblePopUp from "../NonCompatiblePopUp";
import CompPopUpWalloven from "../CompPopUpWalloven";
import MicroWaveCompPopUp from "../MicroWaveCompPopUp";

const Leftmenu = (props) => {
  const { menuList } = useGlobalContext() || {};

  //Mennu Open Close
  let mainMenuState = props.mainMenuVisibility;
  let mainMenuClasses = "mainMenu show";
  mainMenuState
    ? (mainMenuClasses = "mainMenu show")
    : (mainMenuClasses = "mainMenu hide");

    let requiredIds = ['wallOvenCategory','underTheCounterPedestalsCategory'];


  // const cliccck=()=>{
  //     console.log("((((((((((((((((((");
  // }

  // let handleAccClasses="collapse"
  // props.mainAccordionShowHide ? handleAccClasses="expand" : handleAccClasses="collapse";

  // console.log("menuList------",menuList);

    //  const newMenu = menuList.slice(0,9);
       
    //  console.log("newMenu",newMenu);

    const handleKitchenNavigation = ()=>{
      document.location.href = window.sharpthirtyURL
    }

  return (
    <section className="font14rem leftCol">
      <nav className={mainMenuClasses}>
        <div className="mainMenuHeading">
          <Button
            classList="mainMenuBtn"
            clickFunction={props.mainMenuSowHideFunc}
          >
            <CustomeIcon
              alt="Menu Hamburger"
              classList="mainMenuBtnIcon"
            ></CustomeIcon>
          </Button>
          <span className="mainMenuHeadingText">
            Select Your Appliances Model
          </span>
        </div>
        <div className="menu">
          {/* IconMenu */}
          <ul className="menuIcon">

            {
              menuList && menuList?.map((leftmenuIcon, leftmenuIndex) => {
                return (
                  <li key={leftmenuIndex}>
                    <IconMenu
                      index={leftmenuIndex}
                      classList={leftmenuIcon.classList}
                      CategoryTitile={leftmenuIcon.iconBtnClasses + 'Img'}
                      iconClassList={leftmenuIcon.iconBtnIconClasses}
                      TooltipClass={leftmenuIcon.TooltipClass}
                      TooltipTitle={leftmenuIcon.TooltipTitle}
                      mainAccordionFunc={props.mainAccordionFunc}
                      mainAccordionShowHide={props.mainAccordionShowHide}
                      id={leftmenuIcon.id}
                      iconId={leftmenuIcon.id+'IconUniqueId'}
                      camSequence={leftmenuIcon.camSequence}
                      // secondcamSequence={leftmenuIcon.camSequencetwo}
                      camSequencetwo={leftmenuIcon.camSequencetwo}
                      productStateSelectContext={props.productStateSelectContext}
                      menuItems={leftmenuIcon?.items}
                      menuItemLength={leftmenuIcon?.items?.length}
                    ></IconMenu>
                  </li>
                )
              })
            }
          </ul>
          {/* Accordion Menu */}
          <div className="menuAccordion">
            <ul className="menuAccordionList leftMenuHeight">
              {menuList &&
                menuList?.map((menuItem, menu_index) => {

                  // console.log("the data of menuItem is ",menuItem);
                  // console.log("the data of menuItem.id is ",menuItem.id);

                  // console.log(menuItem.title);

                  return (
                    <li className='accordionItem'
                      key={menuItem.id}>
                      <Accordion>
                        <AccordionHeading
                          index={menu_index}
                          id={menuItem.id}
                          accordId={menuItem.id+"cam"}
                          iconName="caret-forward"
                          menuItemLength={menuItem?.items?.length}
                          menuItems={menuItem?.items}
                          CategoryTitile={menuItem.title}
                          ClickAcc={props.mainAccordionFunc}
                          camSequence={menuItem.camSequence}
                          // secondcamSequence={menuItem.camSequencetwo}
                          camSequencetwo={menuItem.camSequencetwo}
                          mainAccordionShowHide={props.mainAccordionShowHide}
                          productStateSelectContext={props.productStateSelectContext}

                          categoryId={menuItem.id+'newData'}

                          // productVisData={menuItem.items}

                        // 
                        // popUp={menuItem}
                        // selectProdP={props.selectProdPlacement}
                        // closeRadioPopUpf={props.closeRadioPopUpfunc}
                        // 
                        >
                        </AccordionHeading>
                        
                        <AccordionContent classList={menuItem.id}>
                          {menuItem?.items?.map((cardItem, card_index) => {
                              let finalId = cardItem?.id ? cardItem.id : ''
                               
                              // console.log("cardItem",cardItem.title.trim());

                            return (
                              <MenuItem
                              
                                itemCategory={menuItem.id}
                                // productId={menuItem.id+'productId'}
                                productId={menuItem.id+finalId}
                                // productId={menuItem.id+cardItem.productVisibilitySequence}

                                key={cardItem.title}
                                cardDetails={cardItem}
                                productStateSelectContext={props.productStateSelectContext}
                                productCardFunc={props.productCardFunc}
                                addToCartHandlerFunc={props.addToCartHandlerFunc}
                                removeCartHandlerFunc={props.removeCartHandlerFunc}
                                classList={cardItem.classes}
                                mainAccordionFunc={props.mainAccordionFunc}
                                ClickAcc={props.mainAccordionFunc}
                                productVisibilitySequencetwo= {cardItem.productVisibilitySequencetwo}
                                
                              ></MenuItem>
                            );
                          })}
                        </AccordionContent>
                      </Accordion>
                        
                      {
                          // (menuItem.id == "underTheCounterPedestalsCategory" && "wallOvenCategory") &&
                          // (menuItem.id == "underTheCounterPedestalsCategory") || (menuItem.id == "wallOvenCategory") 
                          // menuItem.id == ("wallOvenCategory" && "underTheCounterPedestalsCategory") &&
                      //  (menuItem.id == "wallOvenCategory" && menuItem.id == "underTheCounterPedestalsCategory") &&
                        // (menuItem.id == "underTheCounterPedestalsCategory") &&
                        requiredIds.includes(menuItem.id) &&

                        <PopUp
                          closeRadioPopUpf={props.closeRadioPopUpfunc}
                          accordionClick={props.mainAccordionFunc}
                          productStateSelectContext={props.productStateSelectContext}
                          popUp={menuItem}
                          popUpId={menuItem.id}

                          index={menu_index}
                          id={menuItem.id}
                          popUpUniqueId={menuItem.id+"popUpId"}
                          iconName="caret-forward"
                          menuItemLength={menuItem?.items?.length}
                          menuItems={menuItem?.items}
                          CategoryTitile={menuItem.title}
                          // ClickAcc={props.mainAccordionFunc}
                          camSequence={menuItem.camSequence}
                          camSequencetwo={menuItem.camSequencetwo}
                          mainAccordionShowHide={props.mainAccordionShowHide}
                          // productStateSelectContext={props.productStateSelectContext}

                        />
                      }

                        {
                        <CompPopUp
                        closeRadioPopUpf={props.closeRadioPopUpfunc}
                        ></CompPopUp>
                        }

                        {
                          <NonCompatiblePopUp
                           closeRadioPopUpf={props.closeRadioPopUpfunc} 
                          ></NonCompatiblePopUp>
                        }
                        {
                          <CompPopUpWalloven
                          closeRadioPopUpf={props.closeRadioPopUpfunc} 
                          >
                          </CompPopUpWalloven>
                        }

                        {
                          <MicroWaveCompPopUp
                          closeRadioPopUpf = {props.closeRadioPopUpfunc}
                          >
                          </MicroWaveCompPopUp>
                        }
                                                      

                    </li>
                  );
                })}
            </ul>
          </div>
        </div>

        <div className="KitchenNavigationButton" onClick={handleKitchenNavigation}>
          <Button
            classList="NavigationButton"
          >
            <CustomeIcon
              classList="NavigationButtonIcon"
            ></CustomeIcon>
          </Button>
          <span className="NavigationButtonText">
          Go to 30" 3D Showroom
          </span>
        </div>
      </nav>
    </section>
  );
};

export default Leftmenu;
